import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FeatureFlagsService } from '@wsphere/warranties/web';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class CustomRolesFeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagsSvc: FeatureFlagsService
  ) {}

  // Custom-role editing only exists when the flag is on; redirect disabled tenants off the route.
  // Fail closed: if the flag lookup errors, treat it as off and redirect rather than error navigation.
  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const enabled = await firstValueFrom(this.featureFlagsSvc.isEnabled('CUSTOM_ROLES'));
      return enabled ? true : this.router.createUrlTree(['settings']);
    } catch {
      return this.router.createUrlTree(['settings']);
    }
  }
}
